import * as React from "react";
import { cn } from "../lib/utils";

// An uppercase eyebrow label used above a value in stat cards, detail panes,
// form sections, and read-only fields. Replaces the many hand-rolled
//   `text-[10|11px|xs] font-medium|semibold text-muted-foreground
//    uppercase tracking-wide|wider`
// sites that had drifted on size, weight, tracking, and color.
//
// Both variants sit at the 13px type floor (text-xs) — the theme has no
// sub-13px tier — so they differ by WEIGHT + tracking, not size:
//   - "xs" (default) — tight microlabel above a stat value or badge
//                      (normal weight, wider tracking)
//   - "sm"           — section header inside a card ("Groups", "Server")
//                      where the label acts as a subtitle: same 13px, but
//                      SEMIBOLD so it reads as a heading, not a microlabel
//
// Intentionally very small surface area — this is a label, not a form
// Label (that's @/components/label for inputs).

type Size = "xs" | "sm";

interface FieldLabelProps extends React.HTMLAttributes<HTMLParagraphElement> {
  size?: Size;
}

const sizeClasses: Record<Size, string> = {
  xs: "text-xs font-normal tracking-wider",
  sm: "text-xs font-semibold tracking-wide",
};

export function FieldLabel({ className, children, size = "xs", ...props }: FieldLabelProps) {
  return (
    <p
      className={cn(
        "uppercase text-muted-foreground",
        sizeClasses[size],
        className,
      )}
      {...props}
    >
      {children}
    </p>
  );
}
